import Vuex from 'vuex';
import Vue from 'vue';
import { SidebarStates } from './States/sidebar.states';
import { MutationsManager } from './mutations.manager';
import { ShowingsStates } from './States/showings.states';
import { ListingsStates } from './States/listings.states';
import { ReportsStates } from './States/reports.states';
import { AuthStates } from './States/auth.states';
import { PreSaleStates } from './States/presale.states';
import { RifoExlusiveStates } from './States/rifo.exlusive';
import { LPCreatePageStates } from './States/l.p.create.page.states';
import { LPListStates } from './States/l.p.list.states';
import { LPMobileStates } from './States/l.p.mobile.states';

export namespace CommonStates {
  export function factory() {
    Vue.use(Vuex);
    const mutationsManager: MutationsManager.Manager = MutationsManager.factory();
    const storeG = new Vuex.Store({
      state: {
        count: 0,
        sideBar: SidebarStates.sidebarStatesFactory(),
        showings: ShowingsStates.showingsStatesFactory(),
        listings: ListingsStates.listingsStatesFactory(),
        auth: AuthStates.authStatesFactory(),
        reports: ReportsStates.reportsStatesFactory(),
        presaleListStates: PreSaleStates.presaleListStatesFactory(),
        rifoExlusiveListStates: RifoExlusiveStates.rifoExlusiveListStatesFactory(),
        lpCreatePage: LPCreatePageStates.lpCreatePageStatesFactory(),
        lpList: LPListStates.lpListStatesFactory(),
        lpMobile: LPMobileStates.lpMobileStatesFactory(),
      },
      mutations: mutationsManager.mutations,
    });
    return storeG;
  }
}
